import React from "react";
import ReservationBuilderStore from "./stores/ReservationBuilderStore";
import ReservationBuilderConstants from "./constants/ReservationBuilderConstants";
import ReservationBuilderActions from "./actions/ReservationBuilderActions";
import ReservationBuilderNavigation from "./ReservationBuilderNavigation";
import ReservationBuilderLoadingSpinner from "./ReservationBuilderLoadingSpinner";
import ReservationBuilderAccommodationsStep from "./steps/ReservationBuilderAccommodationsStep";
import ReservationBuilderCustomerInformationStep from "./steps/ReservationBuilderCustomerInformationStep";
import ReservationBuilderAdditionalInformationStep from "./steps/ReservationBuilderAdditionalInformationStep";
import ReservationBuilderAddOnsStep from "./steps/ReservationBuilderAddOnsStep";
import ReservationBuilderPaymentInformationStep from "./steps/ReservationBuilderPaymentInformationStep";
import ReservationBuilderReviewStep from "./steps/ReservationBuilderReviewStep";
import ReservationBuilderSuccessStep from "./steps/ReservationBuilderSuccessStep";
import numeral from "numeral";
import { parseISO } from "date-fns";
import ModalButtons from "../ModalButtons/ModalButtons";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  ElementsConsumer,
  CardElement,
} from "@stripe/react-stripe-js";

const _cloneDeep = require("lodash/cloneDeep");

export default class ReservationBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getStateFromStores();
    this._onChange = this._onChange.bind(this);
    this.getStateFromStores = this.getStateFromStores.bind(this);
  }

  async componentDidMount() {
    $(window).on("folioItemSaved", function () {
      ReservationBuilderActions.calculatePricing();
    });
    const stripe = await loadStripe(this.props.public_gateway_key, {
      locale:
        navigator.languages && navigator.languages.length
          ? navigator.languages[0]
          : navigator.language,
    });

    ReservationBuilderStore.addChangeListener(this._onChange);
    var initProps = _cloneDeep(this.props);

    initProps.check_in_date = parseISO(this.props.check_in_date);
    initProps.check_out_date = parseISO(this.props.check_out_date);
    initProps.stripe = stripe;
    ReservationBuilderActions.init(initProps);
  }

  getStateFromStores() {
    return {
      add_ons: ReservationBuilderStore.getAddOns(),
      add_ons_reservation_segment_id:
        ReservationBuilderStore.getAddOnsReservationSegmentId(),
      accommodations: ReservationBuilderStore.getAccommodations(),
      accommodation_with_visible_rates:
        ReservationBuilderStore.getAccommodationWithVisibleRates(),
      active_segment_id: ReservationBuilderStore.getActiveSegmentId(),
      form_fields: ReservationBuilderStore.getFormFields(),
      forms: ReservationBuilderStore.getForms(),
      form_titles: ReservationBuilderStore.getFormTitles(),
      rating_answers: ReservationBuilderStore.getRatingAnswers(),
      emoji_answers: ReservationBuilderStore.getEmojiAnswers(),
      cards: ReservationBuilderStore.getCards(),
      check_in_date: ReservationBuilderStore.getCheckInDate(),
      check_out_date: ReservationBuilderStore.getCheckOutDate(),
      booked_at: ReservationBuilderStore.getBookedAt(),
      currency: ReservationBuilderStore.getCurrency(),
      current_maximum_stay: ReservationBuilderStore.getCurrentMaximumStay(),
      current_minimum_stay: ReservationBuilderStore.getCurrentMinimumStay(),
      date_format: ReservationBuilderStore.getDateFormat(),
      default_payment_gateway:
        ReservationBuilderStore.getDefaultPaymentGateway(),
      did_init: ReservationBuilderStore.getDidInit(),
      errors: ReservationBuilderStore.getErrors(),
      card_errors: ReservationBuilderStore.getCardErrors(),
      existingReservation: ReservationBuilderStore.getExistingReservation(),
      guest_types: ReservationBuilderStore.getGuestTypes(),
      guests: ReservationBuilderStore.getGuests(),
      group_contract: ReservationBuilderStore.getGroupContract(),
      loading: ReservationBuilderStore.getLoading(),
      master_reservation_id: ReservationBuilderStore.getMasterReservationId(),
      numberFormat:
        "0" +
        ($("#delimiter").val() || ",") +
        "0" +
        ($("#separator").val() || ".") +
        "00",
      payment_gateways: ReservationBuilderStore.getPaymentGateways(),
      promo_code: ReservationBuilderStore.getPromoCode(),
      promo_rates_list_path: ReservationBuilderStore.getPromoRatesListPath(),
      products: ReservationBuilderStore.getProducts(),
      room_type_id: ReservationBuilderStore.getRoomTypeId(),
      reservation: ReservationBuilderStore.getReservation(),
      step: ReservationBuilderStore.getStep(),
      type_of_booking: ReservationBuilderStore.getTypeOfBooking(),
      validate_group_contract_path:
        ReservationBuilderStore.getValidateGroupContractPath(),
      booking_folio_items_data_table_path:
        ReservationBuilderStore.getBookingFolioItemsDataTablePath(),
      existing_segments: ReservationBuilderStore.getExistingSegments(),
      stripe: ReservationBuilderStore.getStripe(),
      disableCardNameInput: ReservationBuilderStore.getCardNameInput(),
      displayCardResetButton:
        ReservationBuilderStore.getDisplayCardResetButton(),
      voucher: ReservationBuilderStore.getVoucher(),
      incrementCardElementKey:
        ReservationBuilderStore.getincrementCardElementKey(),
      form_field_address_field_id:
        ReservationBuilderStore.getFormFieldAddressID(),
      date_range_picker_visible:
        ReservationBuilderStore.getDateRangePickerVisible(), 
      show_daily_rentals: ReservationBuilderStore.getShowDailyRentals(),
      today: ReservationBuilderStore.getToday(),
    };
  }

  render() {
    if (this.state.reservation && this.state.reservation.status == "canceled") {
      return (
        <div className="reservation-builder">
          <div className="alert alert-warning">
            <h4 style={{ marginTop: 5 }} className="text-center">
              <strong>
                <span className="ss-lock"></span>{" "}
                {I18n.t("cannot_edit_reservation")}
              </strong>
            </h4>
            <hr />
            <p className="text-center">
              {I18n.t("cannot_change_reservation_that_is_cancelled")}
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="reservation-builder">
          <ReservationBuilderNavigation
            step={this.state.step}
            {...this.state}
          />
          {this.renderErrors()}
          {this.state.stripe ? (
            <Elements stripe={this.state.stripe}>
              <ElementsConsumer>
                {({ stripe, elements }) =>
                  this.renderStepsAndButtons(stripe, elements)
                }
              </ElementsConsumer>
            </Elements>
          ) : null}
          {this.renderReservationTotal()}
          <ReservationBuilderLoadingSpinner show={this.state.loading} />
        </div>
      );
    }
  }

  renderStepsAndButtons = (stripe, elements) => {
    return [
      <ModalButtons
        loading={this.state.loading}
        buttons={this.navButtons(elements)}
        key="buttons"
      />,
      this.renderStep(),
    ];
  };

  navButtons(elements) {
    switch (this.state.step) {
      case ReservationBuilderConstants.ACCOMMODATIONS:
        return [
          {
            name: I18n.t("prev"),
            html_attributes: ["disabled"],
            onClick: (e) => {
              return false;
            },
          },
          {
            name: I18n.t("next"),
            button_classes: ["primary"],
            html_attributes: this.state.date_range_picker_visible ? ["disabled"] : [],
            onClick: (e) => {
              this.gotoStep(
                ReservationBuilderConstants.ADD_ONS,
                ReservationBuilderConstants.NEXT
              );
              return false;
            },
          },
        ];

      case ReservationBuilderConstants.ADD_ONS:
        return [
          {
            name: I18n.t("prev"),
            onClick: (e) => {
              this.gotoStep(
                ReservationBuilderConstants.ACCOMMODATIONS,
                ReservationBuilderConstants.PREV
              );
              return false;
            },
          },
          {
            name: I18n.t("next"),
            button_classes: ["primary"],
            onClick: (e) => {
              this.gotoStep(
                ReservationBuilderConstants.REVIEW_SUMMARY,
                ReservationBuilderConstants.NEXT
              );
              return false;
            },
          },
        ];

      case ReservationBuilderConstants.REVIEW_SUMMARY:
        return [
          {
            name: I18n.t("prev"),
            onClick: (e) => {
              this.gotoStep(
                ReservationBuilderConstants.ADD_ONS,
                ReservationBuilderConstants.PREV
              );
              return false;
            },
          },
          {
            name: I18n.t("next"),
            button_classes: ["primary"],
            onClick: (e) => {
              this.gotoStep(
                ReservationBuilderConstants.CUSTOMER_INFORMATION,
                ReservationBuilderConstants.NEXT
              );
              return false;
            },
          },
        ];

      case ReservationBuilderConstants.CUSTOMER_INFORMATION:
        return [
          {
            name: I18n.t("prev"),
            onClick: (e) => {
              this.gotoStep(
                ReservationBuilderConstants.REVIEW_SUMMARY,
                ReservationBuilderConstants.PREV
              );
              return false;
            },
          },
          {
            name: I18n.t("next"),
            button_classes: ["primary"],
            onClick: (e) => {
              this.props.forms.length > 0
                ? this.gotoStep(
                    ReservationBuilderConstants.ADDITIONAL_INFORMATION,
                    ReservationBuilderConstants.NEXT
                  )
                : this.gotoStep(
                    ReservationBuilderConstants.PAYMENT_INFORMATION,
                    ReservationBuilderConstants.NEXT
                  );
              return false;
            },
          },
        ];

      case ReservationBuilderConstants.ADDITIONAL_INFORMATION:
        return [
          {
            name: I18n.t("prev"),
            onClick: (e) => {
              this.gotoStep(
                ReservationBuilderConstants.CUSTOMER_INFORMATION,
                ReservationBuilderConstants.PREV
              );
              return false;
            },
          },
          {
            name: I18n.t("next"),
            button_classes: ["primary"],
            onClick: (e) => {
              this.gotoStep(
                ReservationBuilderConstants.PAYMENT_INFORMATION,
                ReservationBuilderConstants.NEXT
              );
              return false;
            },
          },
        ];

      case ReservationBuilderConstants.PAYMENT_INFORMATION:
        return [
          {
            name: I18n.t("prev"),
            onClick: (e) => {
              this.props.forms.length > 0
                ? this.gotoStep(
                    ReservationBuilderConstants.ADDITIONAL_INFORMATION,
                    ReservationBuilderConstants.PREV
                  )
                : this.gotoStep(
                    ReservationBuilderConstants.CUSTOMER_INFORMATION,
                    ReservationBuilderConstants.PREV
                  );
              return false;
            },
          },
          {
            name: I18n.t("book_now"),
            button_classes: ["primary"],
            onClick: (e) => {
              // this.setState({ loading: true });
              ReservationBuilderActions.setLoading(true);
              this.generateToken(e, elements);
              return false;
            },
          },
        ];

      case ReservationBuilderConstants.SUCCESS:
        return [
          {
            name: I18n.t("ok"),
            html_attributes: ['data-dismiss="modal"'],
          },
        ];
    }
  }

  gotoStep(step, direction, e) {
    ReservationBuilderActions.gotoStep(step, direction);
  }

  generateToken = async (e, elements) => {
    e.preventDefault();
    ReservationBuilderActions.setLoading(true);
    if (
      this.state.reservation.payment_method &&
      this.state.reservation.payment_method.payment_type == "cash"
    ) {
      if (
        !this.bookingPaymentAmount() ||
        (this.state.voucher &&
          this.bookingPaymentAmount() - this.state.voucher.balance <= 0)
      ) {
        this.gotoStep(
          ReservationBuilderConstants.SUCCESS,
          ReservationBuilderConstants.NEXT
        );
        ReservationBuilderActions.setCardErrorsToState(null);
      } else {
        if (!this.state.reservation.payment_method.cash_drawer) {
          var paymentErrors = {
            header_errors: [I18n.t("select_cash_drawer")],
          };

          ReservationBuilderActions.setCardErrorsToState(paymentErrors);
        } else {
          this.gotoStep(
            ReservationBuilderConstants.SUCCESS,
            ReservationBuilderConstants.NEXT
          );
          ReservationBuilderActions.setCardErrorsToState(null);
        }
      }
    } else if (
      (this.state.reservation.payment_method &&
        this.state.reservation.payment_method.payment_token) ||
      this.state.reservation.card_id
    ) {
      this.gotoStep(
        ReservationBuilderConstants.SUCCESS,
        ReservationBuilderConstants.NEXT
      );
      ReservationBuilderActions.setCardErrorsToState(null);
    } else if (
      (this.bookingPaymentAmount() !== 0 &&
        this.state.reservation.customer.cards &&
        this.state.reservation.customer.cards.length &&
        !this.state.reservation.payment_method) ||
      (!this.bookingPaymentAmount() && !this.state.reservation.payment_method)
    ) {
      const errorString = this.state.voucher
        ? "select_or_enter_payment_details_with_voucher"
        : "select_or_enter_payment_details";
      var cardErrors = {
        header_errors: [I18n.t(errorString)],
      };

      ReservationBuilderActions.setCardErrorsToState(cardErrors);
    } else if (
      !this.state.reservation.payment_method.name_on_card ||
      /\d/.test(this.state.reservation.payment_method.name_on_card)
    ) {
      var cardErrors = {
        header_errors: [I18n.t("name_on_card_error")],
        field_errors: {
          name_on_card_error: I18n.t("name_on_card_error"),
        },
      };

      ReservationBuilderActions.setCardErrorsToState(cardErrors);
    } else if (
      this.state.reservation.payment_method &&
      this.state.reservation.payment_method.name_on_card
    ) {
      var stripe = this.state.stripe;
      var cardElement = elements.getElement(CardElement);

      if (!stripe || !elements) {
        console.log(
          "We should never hit this! Either Stripe or Elements is not loaded!"
        );
        return;
      }

      ReservationBuilderActions.disableCardNameInput();
      const result = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: {
          name: this.state.reservation.payment_method.name_on_card,
        },
      });

      if (result.error) {
        var cardErrors = {
          header_errors: [result.error.message],
          field_errors: { card_validation_error: result.error.message },
        };

        ReservationBuilderActions.setCardErrorsToState(cardErrors);
      } else if (result.paymentMethod) {
        var payment_method = {
          payment_token: result.paymentMethod,
          save_card: this.state.reservation.payment_method.save_card,
        };

        ReservationBuilderActions.changeCardInput(payment_method);

        this.gotoStep(
          ReservationBuilderConstants.SUCCESS,
          ReservationBuilderConstants.NEXT
        );
        ReservationBuilderActions.setCardErrorsToState(null);
      } else {
        console.log("should not hit here potential async issue");
      }
    }
  };

  renderErrors() {
    if (
      (this.state.errors && this.state.errors.length) ||
      (this.state.card_errors &&
        this.state.card_errors.header_errors &&
        this.state.card_errors.header_errors.length) ||
      !this.props.default_payment_gateway
    ) {
      var errors = [];

      if (!this.props.default_payment_gateway) {
        errors.push(I18n.t("default_payment_gateway_not_configured"));
      }

      this.state.errors && this.state.errors.length
        ? this.state.errors.forEach((error, idx) =>
            errors.push(<li key={idx}>{error}</li>)
          )
        : null;
      this.state.card_errors &&
      this.state.card_errors.header_errors &&
      this.state.card_errors.header_errors.length
        ? this.state.card_errors.header_errors.forEach((error, idx) =>
            errors.push(<li key={idx}>{error}</li>)
          )
        : null;
      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderStep() {
    switch (this.state.step) {
      case ReservationBuilderConstants.ACCOMMODATIONS:
        return (
          <ReservationBuilderAccommodationsStep
            key="accomodations"
            {...this.state}
            maxDate={this.props.maxDate}
            date_format={this.props.date_format}
            current_property_date={this.props.current_property_date}
            allow_booked_at={this.props.allow_booked_at}
          />
        );

      case ReservationBuilderConstants.CUSTOMER_INFORMATION:
        return (
          <ReservationBuilderCustomerInformationStep
            {...this.state}
            key="customer-info"
          />
        );

      case ReservationBuilderConstants.ADDITIONAL_INFORMATION:
        return (
          <ReservationBuilderAdditionalInformationStep
            {...this.state}
            key="additional-info"
          />
        );

      case ReservationBuilderConstants.ADD_ONS:
        return (
          <ReservationBuilderAddOnsStep
            key="add-ons"
            {...this.state}
            bookingPaymentAmount={this.bookingPaymentAmount()}
            // products={this.props.products}
          />
        );

      case ReservationBuilderConstants.PAYMENT_INFORMATION:
        return (
          <ReservationBuilderPaymentInformationStep
            {...this.state}
            key="payent-info"
            cash_drawers={this.props.cash_drawers}
            default_cash_drawer={this.props.default_cash_drawer}
            redeem_voucher_path={this.props.redeem_voucher_path}
          />
        );

      case ReservationBuilderConstants.REVIEW_SUMMARY:
        return (
          <ReservationBuilderReviewStep
            {...this.state}
            bookingPaymentAmount={this.bookingPaymentAmount()}
            key="confirm-and-book"
          />
        );

      case ReservationBuilderConstants.SUCCESS:
        return <ReservationBuilderSuccessStep {...this.state} key="success" />;
    }
  }

  renderReservationTotal() {
    if (
      this.state.reservation &&
      this.state.reservation.total_amount &&
      this.state.step !== ReservationBuilderConstants.SUCCESS
    ) {
      var rooms_map = {};
      for (
        var i = 0, ilen = this.state.reservation.reservation_segments.length;
        i < ilen;
        i++
      ) {
        var room_type =
          this.state.reservation.reservation_segments[i].room_type;
        var count = rooms_map[room_type.name];
        if (typeof count == "undefined") {
          rooms_map[room_type.name] = 1;
        } else {
          rooms_map[room_type.name] = count + 1;
        }
      }
      var rooms_summary = "";
      for (var i in rooms_map) {
        rooms_summary = rooms_summary + rooms_map[i] + ": " + i + "<br />";
      }
      var total_nights = 0;
      this.state.reservation.reservation_segments.map((segment) => {
        if (
          segment.number_of_nights &&
          typeof segment.number_of_nights == "number"
        ) {
          total_nights += segment.number_of_nights;
        }
      });

      return (
        <div className="accommodations-price-footer">
          <p
            className="lead"
            style={{ marginBottom: 0, display: "inline-block" }}
          >
            <label style={{ marginBottom: 0 }}>{I18n.t("total")}:</label>&nbsp;
            $
            {numeral(this.state.reservation.total_amount / 100).format(
              this.state.numberFormat
            )}
            ,&nbsp;
            <a
              href="#"
              className="help"
              title={rooms_summary}
              key={new Date().getTime()}
            >
              {this.state.reservation.reservation_segments.length}{" "}
              {(this.state.reservation.reservation_segments.length == 1
                ? I18n.t("room")
                : I18n.t("rooms")
              ).toLowerCase()}
            </a>
            ,&nbsp;
            {total_nights} {I18n.t("nights")}&nbsp;
          </p>
          {this.renderAmountDue()}
          {this.state.voucher ? this.voucherBalance() : null}
          {this.state.voucher ? this.cashOrCardAmount() : null}
        </div>
      );
    } else {
      return null;
    }
  }

  voucherBalance = () => {
    return (
      <p className="lead" style={{ marginBottom: 0, display: "inline-block" }}>
        &nbsp; -{" "}
        <label style={{ marginBottom: 0 }}>{I18n.t("voucher_balance")}:</label>
        &nbsp; $
        {numeral(this.state.voucher.balance / 100).format(
          this.state.numberFormat
        )}
      </p>
    );
  };

  cashOrCardAmount = () => {
    const cashOrCard =
      this.state.reservation.payment_method &&
      this.state.reservation.payment_method.payment_type == "cash"
        ? "cash_amount"
        : "cc_amount";
    const paymentAmount =
      this.bookingPaymentAmount() - this.state.voucher.balance > 0
        ? this.bookingPaymentAmount() - this.state.voucher.balance
        : 0;
    return (
      <p className="lead" style={{ marginBottom: 0, display: "inline-block" }}>
        &nbsp; -{" "}
        <label style={{ marginBottom: 0 }}>{I18n.t(cashOrCard)}:</label>
        &nbsp; ${numeral(paymentAmount / 100).format(this.state.numberFormat)}
      </p>
    );
  };

  renderAmountDue() {
    if (
      this.state.reservation.reservation_segments &&
      this.state.reservation.reservation_segments.length &&
      this.bookingPaymentAmount()
    ) {
      return (
        <p
          className="lead"
          style={{ marginBottom: 0, display: "inline-block" }}
        >
          - <label style={{ marginBottom: 0 }}>{I18n.t("due_today")}:</label>
          &nbsp; $
          {numeral(this.bookingPaymentAmount() / 100).format(
            this.state.numberFormat
          )}
        </p>
      );
    } else {
      return (
        <p
          className="lead"
          style={{ marginBottom: 0, display: "inline-block" }}
        >
          - <label style={{ marginBottom: 0 }}>{I18n.t("due_today")}:</label>
          &nbsp; ${numeral(0).format(this.state.numberFormat)}
        </p>
      );
    }
  }

  bookingPaymentAmount = () => {
    return this.state.reservation.reservation_segments.reduce(
      (acc, segment) => {
        segment.booking_payment_amount
          ? (acc += segment.booking_payment_amount)
          : null;
        return acc;
      },
      0
    );
  };

  _onChange() {
    this.setState(this.getStateFromStores());
  }
}
